'use client'

import { useCartController } from 'cart/hooks/useCartController'
import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ProductLocations } from 'product/types/ProductLocations'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import type { CommonProps } from '../../types/CommonProps'

export type AddToBagProps = Pick<CommonProps, 'product' | 'look'> & {
	readonly location: ProductLocations
	readonly dataTestId?: string
	readonly onError?: (error?: string) => void // TODO: remove error optional
}

export function AddToBagButtonLegacy({
	product,
	look,
	onError,
	dataTestId,
	location,
}: AddToBagProps): React.ReactNode {
	const { t } = useLabels()
	const { isLessThanLarge } = useResponsive()
	const { selectedSize, setHasErrorMessage, openSheet } = useSizes()
	const { selectedColor } = useColors()

	const { add } = useCartController()

	const onAdd = (): void => {
		if (selectedSize) {
			add(
				{
					productId: product.id,
					colorId: selectedColor.id,
					sizeId: selectedSize.id,
					seller: product.seller,
					lookId: look.id,
					lastUnits: !!selectedSize.lastUnits,
				},
				location
			)
		} else if (isLessThanLarge) {
			openSheet(true)
		} else {
			if (onError) {
				onError()
			}
			setHasErrorMessage(true)
		}
	}

	return selectedColor.isSellable ? (
		<ButtonPrimary onClick={onAdd} data-testid={dataTestId}>
			{t('pdp.addToBag.button')}
		</ButtonPrimary>
	) : null
}
